import { presentNotificationModalAtom } from 'app/atoms/ui';
import NotificationWarnImage from 'app/design/images/notification-warn';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { requestNotificationPermission } from 'app/lib/notifications';
import { useUISize } from 'app/utils/web-helpers';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Dimensions, Modal, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();
const WIDTH = Dimensions.get('window').width;
const PAGE_WIDTH = WIDTH * 0.9;

export const NotificationWarnModal = () => {
  const [modalVisible, setModalVisible] = useAtom(presentNotificationModalAtom);
  const { t } = useTranslation('notification-warn');
  const { isLargeUI } = useUISize();

  if (isLargeUI) {
    return null;
  }

  return (
    <Modal
      animationType="slide"
      onRequestClose={() => {
        setModalVisible(!modalVisible);
      }}
      presentationStyle="fullScreen"
      visible={modalVisible}
    >
      <SafeAreaView style={styles.centeredView}>
        <Column gap="spacing.general.x12" width={PAGE_WIDTH}>
          <Column alignItems="center" gap="spacing.general.x4" style={{ paddingBottom: 96 }}>
            <Text fontWeight="700" textAlign="center" variant="headerXSmall">
              {t('title')}
            </Text>
            <Text textAlign="center" variant="bodyLarge">
              {t('subtitle')}
            </Text>

            <NotificationWarnImage />
          </Column>
        </Column>
        <Column
          gap="spacing.general.x4"
          style={{ position: 'absolute', bottom: theme.spacing['spacing.general.x8'] }}
          width={PAGE_WIDTH}
        >
          <Button
            onPress={() => {
              setModalVisible(!modalVisible);
              void requestNotificationPermission();
            }}
            testID="notification-authorize-button"
            variant="primary"
          >
            {t('authorize')}
          </Button>
          <Button
            onPress={() => {
              setModalVisible(!modalVisible);
            }}
            style={{
              borderWidth: 0,
            }}
            variant="secondary"
          >
            {t('later')}
          </Button>
        </Column>
      </SafeAreaView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
});
